<template>
  <div @click="$emit('returnHome')" title="Return to home screen!">
    <div class="home-button">
      <!-- Text that displays 'HOME' -->
      <div class="home-text">HOME</div>
      <div class="center-icon">
        <fa :icon="['fas', 'home']" size="1x" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.home-button {
  position: absolute;
  background: rgb(21.45, 140.4, 87.1);
  border-color: rgb(21.45, 140.4, 87.1);
  right: 0px;
  width: 120px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  gap: 30px;
}
.home-text {
  color: white;
  font-size: 16px;
  text-align: center;
}
.center-icon {
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<script>
export default {
  name: 'MMP_HomeButton'
}
</script>
